export const STORE_TAB_SKELETON_TEST_IDS = {
  root: 'store-tab-skeleton',
  header: 'store-tab-skeleton-header',
  slot: 'store-tab-skeleton-slot',
  footer: 'store-tab-skeleton-footer',
} as const;

export const DEFAULT_STORE_TAB_SKELETON_SLOT_COUNT = 6;
